"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCacheableProviderFactoryObjectFromJS = exports.BaseCacheableProviderFactoryFromJS = exports.BaseCacheableProviderFactory = exports.BaseCacheableProviderRecord = void 0;
const immutable_1 = require("immutable");
exports.BaseCacheableProviderRecord = {
    cacheTTL: 60000,
    cacheType: "Memory" /* EDataSourceCacheType.Memory */,
    enableCache: true,
    advancedPagination: false,
    timeout: 60
};
exports.BaseCacheableProviderFactory = (0, immutable_1.Record)(exports.BaseCacheableProviderRecord);
const BaseCacheableProviderFactoryFromJS = function (data) {
    return (0, exports.BaseCacheableProviderFactory)((0, exports.BaseCacheableProviderFactoryObjectFromJS)(data));
};
exports.BaseCacheableProviderFactoryFromJS = BaseCacheableProviderFactoryFromJS;
const BaseCacheableProviderFactoryObjectFromJS = function (data) {
    return {
        cacheTTL: data.cacheTTL,
        advancedPagination: data.advancedPagination,
        cacheType: data.cacheType,
        enableCache: data.enableCache,
        timeout: data.timeout
    };
};
exports.BaseCacheableProviderFactoryObjectFromJS = BaseCacheableProviderFactoryObjectFromJS;
//# sourceMappingURL=IBaseCacheableProvider.js.map